export const unknownCountry = {
    code: 'UNKNOWN',
    name: 'Unknown',
    flag: '⚠️',
    phoneNumberCode: '',
};

export const internationalCountries = [
    {
        code: 'US',
        name: 'United States of America',
        flag: '🇺🇸',
        phoneNumberCode: '+1',
    },
    {
        code: 'CA',
        name: 'Canada',
        flag: '🇨🇦',
        phoneNumberCode: '+1',
    },
    {
        code: 'GB',
        name: 'United Kingdom',
        flag: '🇬🇧',
        phoneNumberCode: '+44',
    },
    {
        code: 'AU',
        name: 'Australia',
        flag: '🇦🇺',
        phoneNumberCode: '+61',
    },
    {
        code: 'AC',
        name: 'Ascension Island',
        flag: '🇦🇨',
        phoneNumberCode: '+247',
    },
    {
        code: 'AD',
        name: 'Andorra',
        flag: '🇦🇩',
        phoneNumberCode: '+376',
    },
    {
        code: 'AE',
        name: 'United Arab Emirates',
        flag: '🇦🇪',
        phoneNumberCode: '+971',
    },
    {
        code: 'AF',
        name: 'Afghanistan',
        flag: '🇦🇫',
        phoneNumberCode: '+93',
    },
    {
        code: 'AL',
        name: 'Albania',
        flag: '🇦🇱',
        phoneNumberCode: '+355',
    },
    {
        code: 'AM',
        name: 'Armenia',
        flag: '🇦🇲',
        phoneNumberCode: '+374',
    },
    {
        code: 'AO',
        name: 'Angola',
        flag: '🇦🇴',
        phoneNumberCode: '+244',
    },
    {
        code: 'AR',
        name: 'Argentina',
        flag: '🇦🇷',
        phoneNumberCode: '+54',
    },
    {
        code: 'AT',
        name: 'Austria',
        flag: '🇦🇹',
        phoneNumberCode: '+43',
    },
    {
        code: 'AW',
        name: 'Aruba',
        flag: '🇦🇼',
        phoneNumberCode: '+297',
    },
    {
        code: 'AZ',
        name: 'Azerbaijan',
        flag: '🇦🇿',
        phoneNumberCode: '+994',
    },
    {
        code: 'BA',
        name: 'Bosnia and Herzegovina',
        flag: '🇧🇦',
        phoneNumberCode: '+387',
    },
    {
        code: 'BD',
        name: 'Bangladesh',
        flag: '🇧🇩',
        phoneNumberCode: '+880',
    },
    {
        code: 'BE',
        name: 'Belgium',
        flag: '🇧🇪',
        phoneNumberCode: '+32',
    },
    {
        code: 'BF',
        name: 'Burkina Faso',
        flag: '🇧🇫',
        phoneNumberCode: '+226',
    },
    {
        code: 'BG',
        name: 'Bulgaria',
        flag: '🇧🇬',
        phoneNumberCode: '+359',
    },
    {
        code: 'BH',
        name: 'Bahrain',
        flag: '🇧🇭',
        phoneNumberCode: '+973',
    },
    {
        code: 'BI',
        name: 'Burundi',
        flag: '🇧🇮',
        phoneNumberCode: '+257',
    },
    {
        code: 'BJ',
        name: 'Benin',
        flag: '🇧🇯',
        phoneNumberCode: '+229',
    },
    {
        code: 'BN',
        name: 'Brunei Darussalam',
        flag: '🇧🇳',
        phoneNumberCode: '+673',
    },
    {
        code: 'BO',
        name: 'Bolivia, Plurinational State of',
        flag: '🇧🇴',
        phoneNumberCode: '+591',
    },
    {
        code: 'BR',
        name: 'Brazil',
        flag: '🇧🇷',
        phoneNumberCode: '+55',
    },
    {
        code: 'BT',
        name: 'Bhutan',
        flag: '🇧🇹',
        phoneNumberCode: '+975',
    },
    {
        code: 'BW',
        name: 'Botswana',
        flag: '🇧🇼',
        phoneNumberCode: '+267',
    },
    {
        code: 'BY',
        name: 'Belarus',
        flag: '🇧🇾',
        phoneNumberCode: '+375',
    },
    {
        code: 'BZ',
        name: 'Belize',
        flag: '🇧🇿',
        phoneNumberCode: '+501',
    },
    {
        code: 'CD',
        name: 'Congo, Democratic Republic of the',
        flag: '🇨🇩',
        phoneNumberCode: '+243',
    },
    {
        code: 'CF',
        name: 'Central African Republic',
        flag: '🇨🇫',
        phoneNumberCode: '+236',
    },
    {
        code: 'CG',
        name: 'Congo',
        flag: '🇨🇩',
        phoneNumberCode: '+242',
    },
    {
        code: 'CH',
        name: 'Switzerland',
        flag: '🇨🇭',
        phoneNumberCode: '+41',
    },
    {
        code: 'CI',
        name: "Côte d'Ivoire",
        flag: '🇨🇮',
        phoneNumberCode: '+225',
    },
    {
        code: 'CK',
        name: 'Cook Islands',
        flag: '🇨🇰',
        phoneNumberCode: '+682',
    },
    {
        code: 'CL',
        name: 'Chile',
        flag: '🇨🇱',
        phoneNumberCode: '+56',
    },
    {
        code: 'CM',
        name: 'Cameroon',
        flag: '🇨🇲',
        phoneNumberCode: '+237',
    },
    {
        code: 'CN',
        name: 'China',
        flag: '🇨🇳',
        phoneNumberCode: '+86',
    },
    {
        code: 'CO',
        name: 'Colombia',
        flag: '🇨🇴',
        phoneNumberCode: '+57',
    },
    {
        code: 'CR',
        name: 'Costa Rica',
        flag: '🇨🇷',
        phoneNumberCode: '+506',
    },
    {
        code: 'CU',
        name: 'Cuba',
        flag: '🇨🇺',
        phoneNumberCode: '+53',
    },
    {
        code: 'CV',
        name: 'Cabo Verde',
        flag: '🇨🇻',
        phoneNumberCode: '+238',
    },
    {
        code: 'CW',
        name: 'Curaçao',
        flag: '🇨🇼',
        phoneNumberCode: '+599',
    },
    {
        code: 'CY',
        name: 'Cyprus',
        flag: '🇨🇾',
        phoneNumberCode: '+357',
    },
    {
        code: 'CZ',
        name: 'Czechia',
        flag: '🇨🇿',
        phoneNumberCode: '+420',
    },
    {
        code: 'DE',
        name: 'Germany',
        flag: '🇩🇪',
        phoneNumberCode: '+49',
    },
    {
        code: 'DJ',
        name: 'Djibouti',
        flag: '🇩🇯',
        phoneNumberCode: '+253',
    },
    {
        code: 'DK',
        name: 'Denmark',
        flag: '🇩🇰',
        phoneNumberCode: '+45',
    },
    {
        code: 'DO',
        name: 'Dominican Republic',
        flag: '🇩🇴',
        phoneNumberCode: '+1',
    },
    {
        code: 'DZ',
        name: 'Algeria',
        flag: '🇩🇿',
        phoneNumberCode: '+213',
    },
    {
        code: 'EC',
        name: 'Ecuador',
        flag: '🇪🇨',
        phoneNumberCode: '+593',
    },
    {
        code: 'EE',
        name: 'Estonia',
        flag: '🇪🇪',
        phoneNumberCode: '+372',
    },
    {
        code: 'EG',
        name: 'Egypt',
        flag: '🇪🇬',
        phoneNumberCode: '+20',
    },
    {
        code: 'ER',
        name: 'Eritrea',
        flag: '🇪🇷',
        phoneNumberCode: '+291',
    },
    {
        code: 'ES',
        name: 'Spain',
        flag: '🇪🇸',
        phoneNumberCode: '+34',
    },
    {
        code: 'ET',
        name: 'Ethiopia',
        flag: '🇪🇹',
        phoneNumberCode: '+251',
    },
    {
        code: 'FI',
        name: 'Finland',
        flag: '🇫🇮',
        phoneNumberCode: '+358',
    },
    {
        code: 'FJ',
        name: 'Fiji',
        flag: '🇫🇯',
        phoneNumberCode: '+679',
    },
    {
        code: 'FK',
        name: 'Falkland Islands (Malvinas)',
        flag: '🇫🇰',
        phoneNumberCode: '+500',
    },
    {
        code: 'FM',
        name: 'Micronesia, Federated States of',
        flag: '🇫🇲',
        phoneNumberCode: '+691',
    },
    {
        code: 'FO',
        name: 'Faroe Islands',
        flag: '🇫🇴',
        phoneNumberCode: '+298',
    },
    {
        code: 'FR',
        name: 'France',
        flag: '🇫🇷',
        phoneNumberCode: '+33',
    },
    {
        code: 'GA',
        name: 'Gabon',
        flag: '🇬🇦',
        phoneNumberCode: '+241',
    },
    {
        code: 'GE',
        name: 'Georgia',
        flag: '🇬🇪',
        phoneNumberCode: '+995',
    },
    {
        code: 'GF',
        name: 'French Guiana',
        flag: '🇬🇫',
        phoneNumberCode: '+594',
    },
    {
        code: 'GH',
        name: 'Ghana',
        flag: '🇬🇭',
        phoneNumberCode: '+233',
    },
    {
        code: 'GI',
        name: 'Gibraltar',
        flag: '🇬🇮',
        phoneNumberCode: '+350',
    },
    {
        code: 'GL',
        name: 'Greenland',
        flag: '🇬🇱',
        phoneNumberCode: '+299',
    },
    {
        code: 'GM',
        name: 'Gambia',
        flag: '🇬🇲',
        phoneNumberCode: '+220',
    },
    {
        code: 'GN',
        name: 'Guinea',
        flag: '🇬🇳',
        phoneNumberCode: '+224',
    },
    {
        code: 'GP',
        name: 'Guadeloupe',
        flag: '🇬🇵',
        phoneNumberCode: '+590',
    },
    {
        code: 'GQ',
        name: 'Equatorial Guinea',
        flag: '🇬🇶',
        phoneNumberCode: '+240',
    },
    {
        code: 'GR',
        name: 'Greece',
        flag: '🇬🇷',
        phoneNumberCode: '+30',
    },
    {
        code: 'GT',
        name: 'Guatemala',
        flag: '🇬🇹',
        phoneNumberCode: '+502',
    },
    {
        code: 'GW',
        name: 'Guinea-Bissau',
        flag: '🇬🇼',
        phoneNumberCode: '+245',
    },
    {
        code: 'GY',
        name: 'Guyana',
        flag: '🇬🇾',
        phoneNumberCode: '+592',
    },
    {
        code: 'HK',
        name: 'Hong Kong',
        flag: '🇭🇰',
        phoneNumberCode: '+852',
    },
    {
        code: 'HN',
        name: 'Honduras',
        flag: '🇭🇳',
        phoneNumberCode: '+504',
    },
    {
        code: 'HR',
        name: 'Croatia',
        flag: '🇭🇷',
        phoneNumberCode: '+385',
    },
    {
        code: 'HT',
        name: 'Haiti',
        flag: '🇭🇹',
        phoneNumberCode: '+509',
    },
    {
        code: 'HU',
        name: 'Hungary',
        flag: '🇭🇺',
        phoneNumberCode: '+36',
    },
    {
        code: 'ID',
        name: 'Indonesia',
        flag: '🇮🇩',
        phoneNumberCode: '+62',
    },
    {
        code: 'IE',
        name: 'Ireland',
        flag: '🇮🇪',
        phoneNumberCode: '+353',
    },
    {
        code: 'IL',
        name: 'Israel',
        flag: '🇮🇱',
        phoneNumberCode: '+972',
    },
    {
        code: 'IN',
        name: 'India',
        flag: '🇮🇳',
        phoneNumberCode: '+91',
    },
    {
        code: 'IO',
        name: 'British Indian Ocean Territory',
        flag: '🇮🇴',
        phoneNumberCode: '+246',
    },
    {
        code: 'IQ',
        name: 'Iraq',
        flag: '🇮🇶',
        phoneNumberCode: '+964',
    },
    {
        code: 'IR',
        name: 'Iran, Islamic Republic of',
        flag: '🇮🇷',
        phoneNumberCode: '+98',
    },
    {
        code: 'IS',
        name: 'Iceland',
        flag: '🇮🇸',
        phoneNumberCode: '+354',
    },
    {
        code: 'IT',
        name: 'Italy',
        flag: '🇮🇹',
        phoneNumberCode: '+39',
    },
    {
        code: 'JO',
        name: 'Jordan',
        flag: '🇯🇴',
        phoneNumberCode: '+962',
    },
    {
        code: 'JP',
        name: 'Japan',
        flag: '🇯🇵',
        phoneNumberCode: '+81',
    },
    {
        code: 'KE',
        name: 'Kenya',
        flag: '🇰🇪',
        phoneNumberCode: '+254',
    },
    {
        code: 'KG',
        name: 'Kyrgyzstan',
        flag: '🇰🇬',
        phoneNumberCode: '+996',
    },
    {
        code: 'KH',
        name: 'Cambodia',
        flag: '🇰🇭',
        phoneNumberCode: '+855',
    },
    {
        code: 'KI',
        name: 'Kiribati',
        flag: '🇰🇮',
        phoneNumberCode: '+686',
    },
    {
        code: 'KM',
        name: 'Comoros',
        flag: '🇰🇲',
        phoneNumberCode: '+269',
    },
    {
        code: 'KP',
        name: 'North Korea',
        flag: '🇰🇵',
        phoneNumberCode: '+850',
    },
    {
        code: 'KR',
        name: 'South Korea',
        flag: '🇰🇷',
        phoneNumberCode: '+82',
    },
    {
        code: 'KW',
        name: 'Kuwait',
        flag: '🇰🇼',
        phoneNumberCode: '+965',
    },
    {
        code: 'LA',
        name: 'Laos',
        flag: '🇱🇦',
        phoneNumberCode: '+856',
    },
    {
        code: 'LB',
        name: 'Lebanon',
        flag: '🇱🇧',
        phoneNumberCode: '+961',
    },
    {
        code: 'LI',
        name: 'Liechtenstein',
        flag: '🇱🇮',
        phoneNumberCode: '+423',
    },
    {
        code: 'LK',
        name: 'Sri Lanka',
        flag: '🇱🇰',
        phoneNumberCode: '+94',
    },
    {
        code: 'LR',
        name: 'Liberia',
        flag: '🇱🇷',
        phoneNumberCode: '+231',
    },
    {
        code: 'LS',
        name: 'Lesotho',
        flag: '🇱🇸',
        phoneNumberCode: '+266',
    },
    {
        code: 'LT',
        name: 'Lithuania',
        flag: '🇱🇹',
        phoneNumberCode: '+370',
    },
    {
        code: 'LU',
        name: 'Luxembourg',
        flag: '🇱🇺',
        phoneNumberCode: '+352',
    },
    {
        code: 'LV',
        name: 'Latvia',
        flag: '🇱🇻',
        phoneNumberCode: '+371',
    },
    {
        code: 'LY',
        name: 'Libya',
        flag: '🇱🇾',
        phoneNumberCode: '+218',
    },
    {
        code: 'MA',
        name: 'Morocco',
        flag: '🇲🇦',
        phoneNumberCode: '+212',
    },
    {
        code: 'MC',
        name: 'Monaco',
        flag: '🇲🇨',
        phoneNumberCode: '+377',
    },
    {
        code: 'MD',
        name: 'Moldova, Republic of',
        flag: '🇲🇩',
        phoneNumberCode: '+373',
    },
    {
        code: 'ME',
        name: 'Montenegro',
        flag: '🇲🇪',
        phoneNumberCode: '+382',
    },
    {
        code: 'MG',
        name: 'Madagascar',
        flag: '🇲🇬',
        phoneNumberCode: '+261',
    },
    {
        code: 'MH',
        name: 'Marshall Islands',
        flag: '🇲🇭',
        phoneNumberCode: '+692',
    },
    {
        code: 'MK',
        name: 'North Macedonia',
        flag: '🇲🇰',
        phoneNumberCode: '+389',
    },
    {
        code: 'ML',
        name: 'Mali',
        flag: '🇲🇱',
        phoneNumberCode: '+223',
    },
    {
        code: 'MM',
        name: 'Myanmar',
        flag: '🇲🇲',
        phoneNumberCode: '+95',
    },
    {
        code: 'MN',
        name: 'Mongolia',
        flag: '🇲🇳',
        phoneNumberCode: '+976',
    },
    {
        code: 'MO',
        name: 'Macao',
        flag: '🇲🇴',
        phoneNumberCode: '+853',
    },
    {
        code: 'MQ',
        name: 'Martinique',
        flag: '🇲🇶',
        phoneNumberCode: '+596',
    },
    {
        code: 'MR',
        name: 'Mauritania',
        flag: '🇲🇷',
        phoneNumberCode: '+222',
    },
    {
        code: 'MT',
        name: 'Malta',
        flag: '🇲🇹',
        phoneNumberCode: '+356',
    },
    {
        code: 'MU',
        name: 'Mauritius',
        flag: '🇲🇺',
        phoneNumberCode: '+230',
    },
    {
        code: 'MV',
        name: 'Maldives',
        flag: '🇲🇻',
        phoneNumberCode: '+960',
    },
    {
        code: 'MW',
        name: 'Malawi',
        flag: '🇲🇼',
        phoneNumberCode: '+265',
    },
    {
        code: 'MX',
        name: 'Mexico',
        flag: '🇲🇽',
        phoneNumberCode: '+52',
    },
    {
        code: 'MY',
        name: 'Malaysia',
        flag: '🇲🇾',
        phoneNumberCode: '+60',
    },
    {
        code: 'MZ',
        name: 'Mozambique',
        flag: '🇲🇿',
        phoneNumberCode: '+258',
    },
    {
        code: 'NA',
        name: 'Namibia',
        flag: '🇳🇦',
        phoneNumberCode: '+264',
    },
    {
        code: 'NC',
        name: 'New Caledonia',
        flag: '🇳🇨',
        phoneNumberCode: '+687',
    },
    {
        code: 'NE',
        name: 'Niger',
        flag: '🇳🇪',
        phoneNumberCode: '+227',
    },
    {
        code: 'NF',
        name: 'Norfolk Island',
        flag: '🇳🇫',
        phoneNumberCode: '+672',
    },
    {
        code: 'NG',
        name: 'Nigeria',
        flag: '🇳🇬',
        phoneNumberCode: '+234',
    },
    {
        code: 'NI',
        name: 'Nicaragua',
        flag: '🇳🇮',
        phoneNumberCode: '+505',
    },
    {
        code: 'NL',
        name: 'Netherlands',
        flag: '🇳🇱',
        phoneNumberCode: '+31',
    },
    {
        code: 'NO',
        name: 'Norway',
        flag: '🇳🇴',
        phoneNumberCode: '+47',
    },
    {
        code: 'NP',
        name: 'Nepal',
        flag: '🇳🇵',
        phoneNumberCode: '+977',
    },
    {
        code: 'NR',
        name: 'Nauru',
        flag: '🇳🇷',
        phoneNumberCode: '+674',
    },
    {
        code: 'NU',
        name: 'Niue',
        flag: '🇳🇺',
        phoneNumberCode: '+683',
    },
    {
        code: 'NZ',
        name: 'New Zealand',
        flag: '🇳🇿',
        phoneNumberCode: '+64',
    },
    {
        code: 'OM',
        name: 'Oman',
        flag: '🇴🇲',
        phoneNumberCode: '+968',
    },
    {
        code: 'PA',
        name: 'Panama',
        flag: '🇵🇦',
        phoneNumberCode: '+507',
    },
    {
        code: 'PE',
        name: 'Peru',
        flag: '🇵🇪',
        phoneNumberCode: '+51',
    },
    {
        code: 'PF',
        name: 'French Polynesia',
        flag: '🇵🇫',
        phoneNumberCode: '+689',
    },
    {
        code: 'PG',
        name: 'Papua New Guinea',
        flag: '🇵🇬',
        phoneNumberCode: '+675',
    },
    {
        code: 'PH',
        name: 'Philippines',
        flag: '🇵🇭',
        phoneNumberCode: '+63',
    },
    {
        code: 'PK',
        name: 'Pakistan',
        flag: '🇵🇰',
        phoneNumberCode: '+92',
    },
    {
        code: 'PL',
        name: 'Poland',
        flag: '🇵🇱',
        phoneNumberCode: '+48',
    },
    {
        code: 'PM',
        name: 'Saint Pierre and Miquelon',
        flag: '🇵🇲',
        phoneNumberCode: '+508',
    },
    {
        code: 'PS',
        name: 'Palestine',
        flag: '🇵🇸',
        phoneNumberCode: '+970',
    },
    {
        code: 'PT',
        name: 'Portugal',
        flag: '🇵🇹',
        phoneNumberCode: '+351',
    },
    {
        code: 'PW',
        name: 'Palau',
        flag: '🇵🇼',
        phoneNumberCode: '+680',
    },
    {
        code: 'PY',
        name: 'Paraguay',
        flag: '🇵🇾',
        phoneNumberCode: '+595',
    },
    {
        code: 'QA',
        name: 'Qatar',
        flag: '🇶🇦',
        phoneNumberCode: '+974',
    },
    {
        code: 'RE',
        name: 'Réunion',
        flag: '🇷🇪',
        phoneNumberCode: '+262',
    },
    {
        code: 'RO',
        name: 'Romania',
        flag: '🇷🇴',
        phoneNumberCode: '+40',
    },
    {
        code: 'RS',
        name: 'Serbia',
        flag: '🇷🇸',
        phoneNumberCode: '+381',
    },
    {
        code: 'RU',
        name: 'Russian',
        flag: '🇷🇺',
        phoneNumberCode: '+7',
    },
    {
        code: 'RW',
        name: 'Rwanda',
        flag: '🇷🇼',
        phoneNumberCode: '+250',
    },
    {
        code: 'SA',
        name: 'Saudi Arabia',
        flag: '🇸🇦',
        phoneNumberCode: '+966',
    },
    {
        code: 'SB',
        name: 'Solomon Islands',
        flag: '🇸🇧',
        phoneNumberCode: '+677',
    },
    {
        code: 'SC',
        name: 'Seychelles',
        flag: '🇸🇨',
        phoneNumberCode: '+248',
    },
    {
        code: 'SD',
        name: 'Sudan',
        flag: '🇸🇩',
        phoneNumberCode: '+249',
    },
    {
        code: 'SE',
        name: 'Sweden',
        flag: '🇸🇪',
        phoneNumberCode: '+46',
    },
    {
        code: 'SG',
        name: 'Singapore',
        flag: '🇸🇬',
        phoneNumberCode: '+65',
    },
    {
        code: 'SH',
        name: 'Saint Helena, Ascension and Tristan da Cunha',
        flag: '🇹🇦',
        phoneNumberCode: '+290',
    },
    {
        code: 'SI',
        name: 'Slovenia',
        flag: '🇸🇮',
        phoneNumberCode: '+386',
    },
    {
        code: 'SK',
        name: 'Slovakia',
        flag: '🇸🇰',
        phoneNumberCode: '+421',
    },
    {
        code: 'SL',
        name: 'Sierra Leone',
        flag: '🇸🇱',
        phoneNumberCode: '+232',
    },
    {
        code: 'SM',
        name: 'San Marino',
        flag: '🇸🇲',
        phoneNumberCode: '+378',
    },
    {
        code: 'SN',
        name: 'Senegal',
        flag: '🇸🇳',
        phoneNumberCode: '+221',
    },
    {
        code: 'SO',
        name: 'Somalia',
        flag: '🇸🇴',
        phoneNumberCode: '+252',
    },
    {
        code: 'SR',
        name: 'Suriname',
        flag: '🇸🇷',
        phoneNumberCode: '+597',
    },
    {
        code: 'SS',
        name: 'South Sudan',
        flag: '🇸🇸',
        phoneNumberCode: '+211',
    },
    {
        code: 'ST',
        name: 'São Tomé and Príncipe',
        flag: '🇸🇹',
        phoneNumberCode: '+239',
    },
    {
        code: 'SV',
        name: 'El Salvador',
        flag: '🇸🇻',
        phoneNumberCode: '+503',
    },
    {
        code: 'SY',
        name: 'Syria',
        flag: '🇸🇾',
        phoneNumberCode: '+963',
    },
    {
        code: 'SZ',
        name: 'Eswatini',
        flag: '🇸🇿',
        phoneNumberCode: '+268',
    },
    {
        code: 'TD',
        name: 'Chad',
        flag: '🇹🇩',
        phoneNumberCode: '+235',
    },
    {
        code: 'TG',
        name: 'Togo',
        flag: '🇹🇬',
        phoneNumberCode: '+228',
    },
    {
        code: 'TH',
        name: 'Thailand',
        flag: '🇹🇭',
        phoneNumberCode: '+66',
    },
    {
        code: 'TJ',
        name: 'Tajikistan',
        flag: '🇹🇯',
        phoneNumberCode: '+992',
    },
    {
        code: 'TK',
        name: 'Tokelau',
        flag: '🇹🇰',
        phoneNumberCode: '+690',
    },
    {
        code: 'TL',
        name: 'Timor-Leste',
        flag: '🇹🇱',
        phoneNumberCode: '+670',
    },
    {
        code: 'TM',
        name: 'Turkmenistan',
        flag: '🇹🇲',
        phoneNumberCode: '+993',
    },
    {
        code: 'TN',
        name: 'Tunisia',
        flag: '🇹🇳',
        phoneNumberCode: '+216',
    },
    {
        code: 'TO',
        name: 'Tonga',
        flag: '🇹🇴',
        phoneNumberCode: '+676',
    },
    {
        code: 'TR',
        name: 'Türkiye',
        flag: '🇹🇷',
        phoneNumberCode: '+90',
    },
    {
        code: 'TV',
        name: 'Tuvalu',
        flag: '🇹🇻',
        phoneNumberCode: '+688',
    },
    {
        code: 'TW',
        name: 'Taiwan',
        flag: '🇹🇼',
        phoneNumberCode: '+886',
    },
    {
        code: 'TZ',
        name: 'Tanzania',
        flag: '🇹🇿',
        phoneNumberCode: '+255',
    },
    {
        code: 'UA',
        name: 'Ukraine',
        flag: '🇺🇦',
        phoneNumberCode: '+380',
    },
    {
        code: 'UG',
        name: 'Uganda',
        flag: '🇺🇬',
        phoneNumberCode: '+256',
    },
    {
        code: 'UY',
        name: 'Uruguay',
        flag: '🇺🇾',
        phoneNumberCode: '+598',
    },
    {
        code: 'UZ',
        name: 'Uzbekistan',
        flag: '🇺🇿',
        phoneNumberCode: '+998',
    },
    {
        code: 'VE',
        name: 'Venezuela',
        flag: '🇻🇪',
        phoneNumberCode: '+58',
    },
    {
        code: 'VN',
        name: 'Vietnam',
        flag: '🇻🇳',
        phoneNumberCode: '+84',
    },
    {
        code: 'VU',
        name: 'Vanuatu',
        flag: '🇻🇺',
        phoneNumberCode: '+678',
    },
    {
        code: 'WF',
        name: 'Wallis and Futuna',
        flag: '🇼🇫',
        phoneNumberCode: '+681',
    },
    {
        code: 'WS',
        name: 'Samoa',
        flag: '🇼🇸',
        phoneNumberCode: '+685',
    },
    {
        code: 'XK',
        name: 'Kosovo',
        flag: '🇽🇰',
        phoneNumberCode: '+383',
    },
    {
        code: 'YE',
        name: 'Yemen',
        flag: '🇾🇪',
        phoneNumberCode: '+967',
    },
    {
        code: 'ZA',
        name: 'South Africa',
        flag: '🇿🇦',
        phoneNumberCode: '+27',
    },
    {
        code: 'ZM',
        name: 'Zambia',
        flag: '🇿🇲',
        phoneNumberCode: '+260',
    },
    {
        code: 'ZW',
        name: 'Zimbabwe',
        flag: '🇿🇼',
        phoneNumberCode: '+263',
    },
];
